function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var h = Object.defineProperty;
var u = function u(n, t, e) {
  return t in n ? h(n, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : n[t] = e;
};
var c = function c(n, t, e) {
  return u(n, _typeof(t) != "symbol" ? t + "" : t, e), e;
};
import f, { Component as m, createElement as v, Children as b } from "react";
var p = function p(n, t) {
    return (typeof getComputedStyle === "undefined" ? "undefined" : _typeof(getComputedStyle)) < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t);
  },
  y = function y(n) {
    return p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x");
  },
  w = function w(n) {
    if (!(n instanceof HTMLElement)) return window;
    var t = n;
    for (; t && !(t === document.body || t === document.documentElement || !t.parentNode);) {
      if (/(scroll|auto)/.test(y(t))) return t;
      t = t.parentNode;
    }
    return window;
  };
var g = /*#__PURE__*/function (_m) {
  _inherits(g, _m);
  var _super = _createSuper(g);
  function g(e) {
    var _this;
    _classCallCheck(this, g);
    _this = _super.call(this, e);
    c(_assertThisInitialized(_this), "elementObserver");
    c(_assertThisInitialized(_this), "wrapper");
    c(_assertThisInitialized(_this), "lazyLoadHandler", function (e) {
      var o, i;
      var s = _this.props.onContentVisible,
        _e = _slicedToArray(e, 1),
        r = _e[0],
        l = r.isIntersecting;
      if (l) {
        _this.setState({
          visible: !0
        }, function () {
          s && s();
        });
        var a = (o = _this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = _this.elementObserver) == null || i.unobserve(a));
      }
    });
    _this.elementObserver = null, _this.wrapper = /*#__PURE__*/f.createRef(), _this.state = {
      visible: !1
    };
    return _this;
  }
  _createClass(g, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var o;
      this.getEventNode();
      var _this$props = this.props,
        e = _this$props.offset,
        s = _this$props.threshold,
        r = {
          rootMargin: typeof e == "number" ? "".concat(e, "px") : e || "0px",
          threshold: s || 0
        };
      this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
      var l = (o = this.wrapper) == null ? void 0 : o.current;
      l instanceof HTMLElement && this.elementObserver.observe(l);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(e, s) {
      return s.visible;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var s, r;
      var e = (s = this.wrapper) == null ? void 0 : s.current;
      e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
    }
  }, {
    key: "getEventNode",
    value: function getEventNode() {
      var e;
      return w((e = this.wrapper) == null ? void 0 : e.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        e = _this$props2.children,
        s = _this$props2.className,
        r = _this$props2.height,
        l = _this$props2.width,
        o = _this$props2.elementType,
        i = this.state.visible,
        a = {
          height: r,
          width: l
        },
        d = "LazyLoad".concat(i ? " is-visible" : "").concat(s ? " ".concat(s) : "");
      return /*#__PURE__*/v(o || "div", {
        className: d,
        style: a,
        ref: this.wrapper
      }, i && b.only(e));
    }
  }]);
  return g;
}(m);
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});
export { g as default };